import { User, Commute, Segment, LeaderboardResponse } from '../types';

// Allow environment variable override for local development targeting prod API
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

// Log the API URL being used (helpful for debugging)
console.log('API Base URL:', API_BASE_URL);
console.log('Environment:', process.env.NODE_ENV);

export const api = {
  async getUser(username: string): Promise<User> {
    const headers: HeadersInit = {};
    if (API_KEY) {
      headers['x-api-key'] = API_KEY;
    }
    
    const response = await fetch(`${API_BASE_URL}/users/${username}`, {
      headers: Object.keys(headers).length > 0 ? headers : undefined
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch user: ${response.statusText}`);
    }
    return response.json();
  },

  async getCommutes(userId: number): Promise<Commute[]> {
    const headers: HeadersInit = {};
    if (API_KEY) {
      headers['x-api-key'] = API_KEY;
    }
    
    const response = await fetch(`${API_BASE_URL}/commutes?user_id=${userId}`, {
      headers: Object.keys(headers).length > 0 ? headers : undefined
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch commutes: ${response.statusText}`);
    }
    const data = await response.json();
    return data.commutes || [];
  },

  async createSegment(segment: Omit<Segment, 'id'>): Promise<Segment> {
    const headers: HeadersInit = {
      'Content-Type': 'application/json'
    };
    if (API_KEY) {
      headers['x-api-key'] = API_KEY;
    }
    
    const response = await fetch(`${API_BASE_URL}/segments`, {
      method: 'POST',
      headers,
      body: JSON.stringify(segment)
    });
    if (!response.ok) {
      throw new Error(`Failed to create segment: ${response.statusText}`);
    }
    return response.json();
  },

  async getSegments(): Promise<Segment[]> {
    const headers: HeadersInit = {};
    if (API_KEY) {
      headers['x-api-key'] = API_KEY;
    }
    
    const response = await fetch(`${API_BASE_URL}/segments`, {
      headers: Object.keys(headers).length > 0 ? headers : undefined
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch segments: ${response.statusText}`);
    }
    const data = await response.json();
    return data.segments || [];
  },

  async getSegmentLeaderboard(segmentId: number, limit: number = 100, userId?: number): Promise<LeaderboardResponse> {
    const headers: HeadersInit = {};
    if (API_KEY) {
      headers['x-api-key'] = API_KEY;
    }
    
    let url = `${API_BASE_URL}/segment-results/leaderboard/${segmentId}?limit=${limit}`;
    if (userId) {
      url += `&user_id=${userId}`;
    }
    
    const response = await fetch(url, {
      headers: Object.keys(headers).length > 0 ? headers : undefined
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch segment leaderboard: ${response.statusText}`);
    }
    return response.json();
  }
};
